import React, { useEffect, useState } from "react";
import TranslatedText from "./TranslatedText";
import {Typography, Box, Card } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EventsContext from "./EventsContext";
import CalendarCards from "./CalendarCards";
import "../Styles/Calendar.css";
import dayjs from "dayjs";

const Calendar = () => {
  // const [selectedDate, setSelectedDate] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(
    new Date().setMonth(new Date().getMonth() + 1)
  );

  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);

  const handleDateChange = (date) => {
    setStartDate(date);
    setEndDate(date);
  };

  const exampleEvents = [
    [
      1,
      "Українська кулінарія",
      "2023-05-01 14:00",
      "2023-05-01 16:00",
      "Українська кулінарія для початківців",
      "Приєднуйтесь до вступного курсу з української кулінарії та навчіться готувати класичні страви разом з іншими біженцями.",
      "Місцевий кулінарний клуб",
      "Кулінарія",
      "Кухонна вулиця 1",
      "Ларвік",
      "Без обмежень",
    ],
    [
      2,
      "Норвезький мовний курс",
      "2023-05-02 18:00",
      "2023-05-02 20:00",
      "Норвезький мовний курс для українських біженців",
      "Приєднуйтесь до норвезького мовного курсу, спеціально розробленого для українських біженців. Курс допоможе вам покращити знання норвезької мови.",
      "Норвезьке навчання",
      "Освіта",
      "Шкільна вулиця 2",
      "Скієн",
      "18+",
    ],
    [
      3,
      "Дитячий вечір культури",
      "2023-05-05 17:00",
      "2023-05-05 19:00",
      "Дитячий вечір культури з українською та норвезькою культурою",
      "Вечір ігор, пісень та активностей з української та норвезької культур для дітей.",
      "Сімейний клуб",
      "Діти і сім’я",
      "Будинок культури 3",
      "Порсгрунн",
      "Без обмежень",
    ],
    [
      4,
      "Українсько-норвезька музична майстерня",
      "2023-05-10 14:00",
      "2023-05-10 16:00",
      "Музична майстерня з українськими та норвезькими народними мелодіями",
      "Приєднуйтесь до музичної майстерні, де ми досліджуємо українські та норвезькі народні мелодії та вчимося грати разом.",
      "Місцева музична школа",
      "Музика",
      "Музична вулиця 4",
      "Сандефьорд",
      "Без обмежень",
    ],
    [
      5,
      "Курс пошуку роботи",
      "2023-05-15 10:00",
      "2023-05-15 12:00",
      "Курс пошуку роботи для українських біженців",
      "Приєднуйтесь до курсу пошуку роботи, спеціально розробленого для українських біженців, та дізнайтеся, як подавати заявки на роботу в Норвегії.",
      "NAV",
      "Кар’єра",
      "Офіс NAV 5",
      "Хортен",
      "18+",
    ],
    [
      6,
      "Пригоди на маршруті",
      "2023-05-20 12:00",
      "2023-05-20 15:00",
      "Пригоди на маршруті для українських сімей",
      "Досліджуйте норвезьку природу разом з іншими українськими сім'ями. Приєднуйтесь до проведення екскурсії лісом та насолоджуйтесь прекрасними пішохідними маршрутами.",
      "Походи на свіжому повітрі",
      "Природа",
      "Лісова вулиця 6",
      "Тунсберг",
      "Без обмежень",
    ],
    [
      7,
      "Українська майстерня ремесел",
      "2023-05-25 15:00",
      "2023-05-25 17:00",
      "Українська майстерня ремесел для дорослих",
      "Вивчайте традиційні українські техніки ремесел та створюйте прекрасні художні твори разом з іншими українськими біженцями.",
      "Клуб мистецтва",
      "Ремесла",
      "Вулиця мистецтва 7",
      "Бамбле",
      "18+",
    ],
    [
      8,
      "Український вечір танців та культури",
      "2023-05-28 18:00",
      "2023-05-28 21:00",
      "Український вечір танців та культури",
      "Приєднуйтесь до вечора з традиційними українськими танцями та музикою. Ви матимете можливість вивчити деякі танцювальні рухи та познайомитись з українською культурою.",
      "Культурна асоціація",
      "Танець та культура",
      "Будинок культури 8",
      "Нотодден",
      "Без обмежень",
    ],
    [
      9,
      "Кіно вечір",
      "2023-05-30 19:00",
      "2023-05-30 21:00",
      "Український кіновечір для дорослих",
      "Приєднуйтесь до затишного кіновечора, де ми будемо дивитися український фільм та обговорювати його після перегляду. Це чудова нагода познайомитись з іншими українськими біженцями.",
      "Кіноклуб",
      "Кіно",
      "Кіновулиця 9",
      "Сілвер",
      "18+",
    ],
    [
      10,
      "Сімейний день у парку",
      "2023-05-31 12:00",
      "2023-05-31 15:00",
      "Сімейний день у парку для українських родин",
      "Заберіть свою родину і приєднуйтесь до інших українських родин на сімейний день у парку. Будуть організовані ігри та розваги для дітей та дорослих. Це чудовий спосіб провести час на свіжому повітрі і зустрітись з іншими родинами.",
      "Сімейний клуб",
      "Сім’я та діти",
      "Паркова вулиця 10",
      "Крагеро",
      "Без обмежень",
    ],
  ];

  const initDatabase = () => {
    const exampleEventsData = JSON.stringify(exampleEvents);
    if (!localStorage.getItem("events")) {
      localStorage.setItem("events", exampleEventsData);
    }
  };

  const getEvents = () => {
    const eventsData = localStorage.getItem("events");
    if (eventsData) {
      return JSON.parse(eventsData);
    } else {
      return [];
    }
  };

  const fetchEvents = () => {
    const allEvents = getEvents();
    const filteredEvents = allEvents.filter((event) => {
      const eventStartDate = new Date(event[2]);
      eventStartDate.setHours(0, 0, 0, 0);
      const eventEndDate = new Date(event[3]);
      eventEndDate.setHours(0, 0, 0, 0);

      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);

      return (
        (eventStartDate >= start && eventStartDate <= end) ||
        (eventEndDate >= start && eventEndDate <= end)
      );
    });
    setFilteredEvents(filteredEvents);
  };

  useEffect(() => {
    initDatabase();
    fetchEvents();
  }, [startDate, endDate]);

  return (
    <>
      <Box className="activ-box" component="main" sx={{ p: 3 }}>
        <Typography variant="h2" fontSize={40} marginTop={"10vh"} gutterBottom>
          <TranslatedText defaultText="Календар" />
        </Typography>
        <Typography
          className="calendar-alert"
          variant="h6"
          sx={{ color: "red", fontSize: "17px", fontWeight: "400" }}
        >
          <TranslatedText defaultText="Наразі лише для демонстрації"></TranslatedText>
        </Typography>
        <div className="container">
          <div className="calendar-item">
            <Card
              sx={{
                marginTop: "5vh",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="label-items">
                  <div className="calendar-label">
                    <label>
                      {<TranslatedText defaultText="Виберіть дату" />}:
                    </label>
                  </div>
                  <div calendar-picker>
                    <DatePicker
                      selected={startDate}
                      defaultValue={dayjs(startDate)}
                      onChange={(date) => setStartDate(date)}
                    />
                  </div>
                  <div>
                    <label>
                      {<TranslatedText defaultText="Виберіть дату" />}:
                    </label>
                  </div>
                  <div calendar-picker>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                    />
                  </div>
                </div>
              </LocalizationProvider>
            </Card>
          </div>
          <CalendarCards events={filteredEvents} />
        </div>
      </Box>
    </>
  );
};

export default Calendar;
